import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
// import Cta from '../Cta';

import Hero12 from '../Hero/Hero12';
const heroSocialLinks = [
  {
    name: 'FaceBook',
    links: '/',
  },
  {
    name: 'Twitter',
    links: '/',
  },
];

const showcaseData = [
  {
    introTitle: 'Releasing 30 July 2026',
    title: 'Spider-Man: Brand New Day',
    videoUrl: 'video/video-3.webm',
    // href: '/case-study/case-study-details',
  },
  {
    introTitle: 'Releasing 26 August 2026',
    title: 'Toxic',
    videoUrl: 'video/video-1.webm',
    // href: '/case-study/case-study-details',
  },
  {
    introTitle: 'Releasing 18 December 2026',
    title: 'Avengers: Doomsday',
    videoUrl: 'video/video-2.webm',
    href: '/case-study/case-study-details',
  },
];

export default function BlogPage() {
  pageTitle('Blog');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero12
        heroSocialLinks={heroSocialLinks}
        socialLinksHeading="Follow Us"
        showcaseData={showcaseData}
      />
      {/* Start CTA Section */}
      <Div className="container">
        {/* <Cta
                          title="Let’s disscuse make <br />something <i>cool</i> together"
                          btnText="Apply For Meeting"
                          btnLink="/contact"
                          bgSrc="/images/cta_bg_3.jpeg"
                        /> */}
      </Div>
      {/* End CTA Section */}
    </>

  );
}
